export const THEMES = {
  LIGHT: "light",
  DARK: "dark",
};
export const JWT_SECRET =
  "s038-pwpppwpeok-dffMjfjriru44030423-edmmfvnvdmjrp4l4k";
